import { FC, useContext } from 'react';

import {
  Button,
  InfoBlock,
  PasswordInput,
  PhoneInput,
} from '@smartshell/ui-kit';
import { Controller, useForm } from 'react-hook-form';

import { AuthContext } from 'auth';
import { LocalizationContext } from 'localization';

import { ICredentialsProps, IFormCredentialsValues } from '../interfaces';
import s from './Credentials.module.scss';

export const Credentials: FC<ICredentialsProps> = ({ onSubmit }) => {
  const { t } = useContext(LocalizationContext);

  const {
    data: { error: authModuleError },
  } = useContext(AuthContext);

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<IFormCredentialsValues>();

  return (
    <form
      className={`${s.form} ym-hide-content ym-disable-submit`}
      onSubmit={handleSubmit(onSubmit)}
      data-testid="credentials"
    >
      <header className={s.header}>{t('login.title')}</header>
      <div className={s['fields-container']}>
        {authModuleError && (
          <InfoBlock
            title={t(authModuleError.title)}
            message={t(authModuleError.message)}
          />
        )}
        <Controller
          render={({ field: { ...field }, fieldState: { error } }) => (
            <PhoneInput
              dataTestId="phone"
              {...field}
              error={error?.message}
              title={t('phone')}
              bordered
            />
          )}
          name="login"
          control={control}
          defaultValue=""
          rules={{ required: t('errors.required') }}
        />
        <Controller
          render={({ field, fieldState: { error } }) => (
            <PasswordInput
              dataTestId="password"
              {...field}
              error={error?.message}
              title={t('password')}
              bordered
            />
          )}
          name="password"
          control={control}
          defaultValue=""
          rules={{ required: t('errors.required') }}
        />
      </div>
      <Button type="submit" isLoading={isSubmitting} fullWidth>
        {t('login.submit')}
      </Button>
    </form>
  );
};
